import { render, staticRenderFns } from "./LeakListIndex.vue?vue&type=template&id=4afae6e3&scoped=true"
import script from "./LeakListIndex.vue?vue&type=script&lang=ts"
export * from "./LeakListIndex.vue?vue&type=script&lang=ts"
import style0 from "./LeakListIndex.vue?vue&type=style&index=0&id=4afae6e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afae6e3",
  null
  
)

export default component.exports